var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M10.65 2.5a2.75 2.75 0 0 1 3.701.971l.002.004 8.47 14.14.006.01a2.751 2.751 0 0 1-2.351 4.125H3.522a2.748 2.748 0 0 1-2.352-4.125l.006-.01 8.47-14.14.644.385-.641-.389a2.75 2.75 0 0 1 1.002-.97Zm.282 1.747-.001.002-8.464 14.13a1.25 1.25 0 0 0 1.067 1.871h16.931a1.25 1.25 0 0 0 1.068-1.87L13.068 4.249v-.002a1.25 1.25 0 0 0-2.136 0ZM12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H12Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlert;